import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';
import React from 'react';

const RenderMathOrText = ({ html, className = "" }) => {
  if (!html) return null;

  const handleLinkClick = (e) => {
    // Handle link clicks
    if (e.target.tagName === 'A') {
      e.preventDefault();
      const href = e.target.getAttribute('href');
      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    }
  };

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const renderNode = (node, index) => {
    if (node.nodeType === 3) {
      const text = node.textContent;

      // Block math $$...$$
      const blockMatch = text.match(/\$\$(.+?)\$\$/gs);
      if (blockMatch) {
        const parts = text.split(/\$\$(.+?)\$\$/s);
        return parts.map((part, i) => {
          if (i % 2 === 1) return <BlockMath key={`${index}-${i}`} math={part} />;
          return <span key={`${index}-${i}`}>{part}</span>;
        });
      }

      // Inline math $...$
      const inlineMatch = text.match(/\$(.+?)\$/g);
      if (inlineMatch) {
        const parts = text.split(/\$(.+?)\$/);
        return parts.map((part, i) => {
          if (i % 2 === 1) return <InlineMath key={`${index}-${i}`} math={part} />;
          return <span key={`${index}-${i}`}>{part}</span>;
        });
      }

      return <span key={index}>{text}</span>;
    }

    if (node.nodeType === 1) {
      const children = Array.from(node.childNodes).map((child, i) => renderNode(child, i));
      
      switch (node.tagName.toLowerCase()) {
        case 'strong': 
          return <strong key={index}>{children}</strong>;
        case 'em': 
          return <em key={index}>{children}</em>;
        case 'p': 
          return <p key={index}>{children}</p>;
        case 'br': 
          return <br key={index} />;
        case 'a': 
          return (
            <a 
              key={index}
              href={node.getAttribute('href') || '#'}
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                color: '#2563eb', 
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={(e) => {
                e.preventDefault();
                const href = node.getAttribute('href');
                if (href && href !== '#') {
                  window.open(href, '_blank', 'noopener,noreferrer');
                }
              }}
            >
              {children}
            </a>
          );
        case 'div':
        case 'span':
          return (
            <span key={index} style={{ display: 'inline' }}>
              {children}
            </span>
          );
        default: 
          return <span key={index}>{children}</span>;
      }
    }

    return null;
  };

  return (
    <div 
      className={`render-math-content ${className}`}
      onClick={handleLinkClick}
      style={{ pointerEvents: 'auto' }}
    >
      {Array.from(doc.body.childNodes).map((node, index) => renderNode(node, index))}
    </div>
  );
};

export default RenderMathOrText;